const jobSearchStatusesMap = {
  actively_looking: {
    id: 'actively_looking',
    label: "Yes, I'm looking for a new job and ready to interview",
  },
  ready_to_interview: {
    id: 'ready_to_interview',
    label: "Not actively looking, but I'm ready to interview for interesting positions",
  },
  unsure: {
    id: 'unsure',
    label: "Not sure yet, I'm looking to learn more about my options",
  },
  not_looking: {
    id: 'not_looking',
    label: 'No, I’m not looking to start a job search right now',
  },
}

export const jobSearchStatuses = Object.values(jobSearchStatusesMap)
